// extracted by mini-css-extract-plugin
module.exports = {"form":"BankDataForm_form__ZuUUC","button":"BankDataForm_button__lPeTx"};